import React from 'react';
import { cx } from '@emotion/css';
import * as styles from '../assignments/assignments.style';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

function CreateEvent(props) {
    let { id, category, count } = props.eventcategory;


    function createEvents() {
        ////console.log("Calling Create Events")
        props.onclick()
    }
    return (
        <div 
            style={{ 
                cursor: 'pointer', 
                minHeight: '350px', 
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                position: 'relative',
                pointerEvents: 'auto'
            }} 
            onClick={(e) => { console.log('Create Event clicked'); createEvents(); }}
        >
            <div 
                className="create-icon-wrapper"
                style={{ 
                    width: '70px', 
                    height: '70px', 
                    borderRadius: '50%', 
                    background: '#000000', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center',
                    marginBottom: '20px',
                    boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
                    transition: 'all 0.3s ease'
                }}
            >
                <FontAwesomeIcon icon={faPlus} style={{ fontSize: '24px', color: '#ffffff' }} />
            </div>
            <div className={cx(styles.cardTitle)} style={{ fontSize: '1.2rem' }}>Create New Challenge</div>
            <div className={cx(styles.cardCount)}>Setup a new event</div>
        </div>
    );
}

export default CreateEvent;
